'use client';

import { createContext } from 'react';

import type { ComboboxFloatingContextInterface } from '../types/use-combobox.types';

/**
 * Carries the floating-ui-bridged data whose identity changes on every
 * render by library contract (`context` from `useFloating`,
 * `getFloatingProps` from `useInteractions`). Only `Combobox.Content`
 * consumes it; siblings stay on the stable `ComboboxRootContext` and
 * therefore don't re-render on every parent render.
 */
export const ComboboxFloatingContext = createContext({} as ComboboxFloatingContextInterface);

ComboboxFloatingContext.displayName = 'Combobox.Floating.Context';
